import axios from 'axios';

// Set the base URL dynamically based on the environment
// salvataxllc is the backend | salvataxllc-client is the frontend
//const API_BASE_URL =
//    process.env.NODE_ENV === 'production'
//        ? 'https://backend.salva.tax' // Production API URL
//        : 'http://localhost:5000';    // Development API URL

const API_BASE_URL = 'https://backend.salva.tax';

// API Instance
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});


// User Authentication
export const registerUser = async (username, password) => {
    return await api.post('/register', { username, password });
};

export const loginUser = async (username, password) => {
    return await api.post('/login', { username, password });
};

// Fetch User Data
export const getUserData = async (token) => {
    return await api.get('/userdata', {
        headers: { Authorization: `Bearer ${token}` },
    });
};

export default api;